import React, { useState } from "react";
import { NavHashLink } from "react-router-hash-link";
import { Col, Row } from "react-bootstrap";

const TechnologyBannerComponent = ({ data }) => {
  const [technologyData] = useState(data);
  return (
    <div className="container">
      <Row className="justify-content-center">
        {technologyData.map((e, index) => {
          return (
            <Col
              md={2}
              sm={6}
              xs={6}
              className="d-flex justify-content-center"
              key={index}
            >
              <NavHashLink to={e.href} className="border-0 ">
                <div className="technology-banner-block rounded p-3 shadow-sm w-80 mx-auto text-center">
                  <img src={e.image} className="w-50 h-50 mb-3" alt={e.title} />
                  <h6 className="f-4">{e.title}</h6>
                </div>
              </NavHashLink>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default TechnologyBannerComponent;
